import React from 'react';
import ReactDOM from 'react-dom/client';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';
import App from './App';
import { initPostHog, posthog } from './lib/posthog';
import './App.css';

initPostHog();

function AppErrorFallback({ error }) {
  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif', maxWidth: 480 }}>
      <h1 style={{ fontSize: '1.25rem', margin: '0 0 0.5rem' }}>Something went wrong</h1>
      <p style={{ color: '#555', margin: '0 0 1rem' }}>
        Reload the page. If it persists, contact the deal desk.
      </p>
      {error?.message ? (
        <pre style={{ fontSize: 12, whiteSpace: 'pre-wrap', color: '#991b1b' }}>{error.message}</pre>
      ) : null}
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <PostHogErrorBoundary fallback={AppErrorFallback}>
        <App />
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>,
);
